import { Box, Typography } from "@mui/material";
import { memo } from "react";

const Field = ({ label, value, mono = false, muted = false }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
    <Typography
      sx={{
        fontSize: 10,
        color: '#94a3b8',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: 1.2,
        mb: 0.3,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: 12.5,
        color: muted ? '#94a3b8' : '#334155',
        fontWeight: 400,
        fontFamily: mono
          ? 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace !important'
          : 'inherit',
        fontVariantNumeric: 'tabular-nums',
        lineHeight: 1.4,
        wordBreak: mono ? "break-all" : "normal",
        overflowWrap: mono ? "anywhere" : "normal",
      }}
      title={label}
    >
      {value || '—'}
    </Typography>
  </Box>
);

export default memo(Field)